(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rb-about"] && !Shopify.designMode) return;
  try {
    
  /* Čísla se po zobrazení „načtou" — dopočítají se z 0 na cílovou hodnotu.
     Nečíselnou příponu (%, +) zachová. Respektuje prefers-reduced-motion. */
  (function () {
    function animate(el) {
      var raw = el.getAttribute('data-final') || el.textContent;
      el.setAttribute('data-final', raw);
      var num = parseInt(raw.replace(/\s/g, '').match(/-?\d+/), 10);
      if (isNaN(num)) return;
      var suffix = raw.replace(/^\s*-?\d+/, '');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { el.textContent = raw; return; }
      var dur = 1100, t0 = null;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3); /* easeOutCubic */
        el.textContent = Math.round(num * e) + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = raw;
      }
      requestAnimationFrame(step);
    }

    document.querySelectorAll('[data-rb-stats]').forEach(function (group) {
      var values = group.querySelectorAll('[data-rb-count]');
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          values.forEach(animate);
          obs.disconnect();
        });
      }, { threshold: .4 });
      io.observe(group);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-bestsellers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.rb-best').forEach(function (section) {
    var tabs = section.querySelectorAll('[data-rb-tab]');
    var items = section.querySelectorAll('.rb-best__item');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var match = tab.getAttribute('data-rb-tab');

        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        items.forEach(function (item) {
          var group = item.getAttribute('data-group') || '';
          item.hidden = match !== '' && group.indexOf(match) === -1;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-header"]) return;
  try {
    
  document.querySelectorAll('[data-rb-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var navbar = btn.closest('.rb-header').querySelector('.rb-header__navbar');
      if (!navbar) return;
      var open = navbar.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* Podmenu: šipka vedle položky ho otevře/zavře (dotyk, mobil, klávesnice).
     Na desktopu se navíc otevírá najetím myší (čisté CSS). */
  (function () {
    var items = document.querySelectorAll('[data-rb-sub]');
    if (!items.length) return;
    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var t = item.querySelector('[data-rb-sub-toggle]');
      if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    items.forEach(function (item) {
      var t = item.querySelector('[data-rb-sub-toggle]');
      if (!t) return;
      t.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !item.classList.contains('is-open');
        items.forEach(function (other) { if (other !== item) setOpen(other, false); });
        setOpen(item, open);
      });
    });
    document.addEventListener('click', function (e) {
      items.forEach(function (item) { if (!item.contains(e.target)) setOpen(item, false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      items.forEach(function (item) { setOpen(item, false); });
    });
  })();

  /* Navigace je nahoře jako klasická; při scrollu DOLŮ se schová, při scrollu
     NAHORU (kolečkem) se zase objeví. Nezávisí to na hero — schová se hned, jak
     jedeš dolů, kdekoliv na stránce. Úplně nahoře je vždy vidět. */
  (function () {
    var header = document.querySelector('.rb-header');
    if (!header) return;
    var wrap = header.closest('.shopify-section') || header;
    wrap.classList.add('rb-sticky-header');

    var navbar = header.querySelector('.rb-header__navbar');
    var lastY = window.scrollY;
    var ticking = false;

    function update() {
      ticking = false;
      var y = window.scrollY < 0 ? 0 : window.scrollY;
      var d = y - lastY;
      if (Math.abs(d) < 4) { lastY = y; return; }   // ignoruj drobné pohyby
      var menuOpen = navbar && navbar.classList.contains('is-open');
      if (y <= 4 || menuOpen) {
        wrap.classList.remove('is-hidden');           // úplně nahoře / otevřené menu → vidět
      } else if (d > 0) {
        wrap.classList.add('is-hidden');              // scroll dolů → schovat
      } else {
        wrap.classList.remove('is-hidden');           // scroll nahoru → ukázat
      }
      lastY = y;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  })();

  /* Našeptávač — nativní Shopify Predictive Search (/search/suggest.json).
     Píše-li uživatel do hledání, pod polem se rovnou ukazují produkty
     (obálka + název + autor). Bez appky. */
  (function () {
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

    document.querySelectorAll('.rb-header__search').forEach(function (form) {
      var input = form.querySelector('.rb-header__search-input');
      var box = form.querySelector('[data-rb-suggest]');
      if (!input || !box) return;
      var timer, controller;

      function hide() { box.hidden = true; }
      function show() { box.hidden = false; }

      function render(q, products) {
        if (!products || !products.length) {
          box.innerHTML = '<p class="rb-header__suggest-empty">Nic jsme nenašli.</p>';
          show(); return;
        }
        var items = products.slice(0, 6).map(function (p) {
          var src = p.image || (p.featured_image && p.featured_image.url) || '';
          var media = src
            ? '<span class="rb-header__suggest-media"><img src="' + src + '" alt="" loading="lazy"></span>'
            : '<span class="rb-header__suggest-media"></span>';
          var author = p.vendor ? '<span class="rb-header__suggest-author">' + esc(p.vendor) + '</span>' : '';
          return '<a class="rb-header__suggest-item" role="option" href="' + p.url + '">' +
            media +
            '<span class="rb-header__suggest-main">' +
              '<span class="rb-header__suggest-title">' + esc(p.title) + '</span>' + author +
            '</span></a>';
        }).join('');
        items += '<a class="rb-header__suggest-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">Zobrazit všechny výsledky pro „' + esc(q) + '"</a>';
        box.innerHTML = items;
        show();
      }

      function fetchSuggest(q) {
        if (controller) controller.abort();
        controller = new AbortController();
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', {
          headers: { 'Accept': 'application/json' }, signal: controller.signal
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var res = data && data.resources && data.resources.results;
            render(q, res ? res.products : []);
          })
          .catch(function () { /* přerušený/selhaný request ignorujeme */ });
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (q.length < 2) { hide(); return; }
        clearTimeout(timer);
        timer = setTimeout(function () { fetchSuggest(q); }, 180);
      });
      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2 && box.innerHTML) show();
      });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ---- odpočet (jeden nebo víc slidů) ---- */
    function pad(n) { return String(n).padStart(2, '0'); }
    /* 1 den · 2–4 dny · 5+ dní */
    function daysWord(d) { return d === 1 ? 'den' : (d >= 2 && d <= 4 ? 'dny' : 'dní'); }
    function tick(el, end) {
      var diff = Math.floor((end - Date.now()) / 1000);
      if (diff <= 0) { el.textContent = '00 : 00 : 00'; return false; }
      var d = Math.floor(diff / 86400), h = Math.floor((diff % 86400) / 3600),
          m = Math.floor((diff % 3600) / 60), s = diff % 60;
      el.textContent = (d > 0 ? d + ' ' + daysWord(d) + '  ' : '') + pad(h) + ' : ' + pad(m) + ' : ' + pad(s);
      return true;
    }
    document.querySelectorAll('[data-rb-countdown]').forEach(function (el) {
      var end = new Date(el.getAttribute('data-end')).getTime();
      if (isNaN(end)) return;
      if (tick(el, end) === false) return;
      var id = setInterval(function () { if (tick(el, end) === false) clearInterval(id); }, 1000);
    });

    /* ---- slider (posun přes transform, ovládají jen tečky/autoplay) ---- */
    document.querySelectorAll('[data-rb-hero]').forEach(function (root) {
      var track = root.querySelector('[data-rb-hero-track]');
      var slides = track ? Array.prototype.slice.call(track.children) : [];
      if (!track || slides.length < 2) return;

      var dotsWrap = root.querySelector('[data-rb-hero-dots]');
      var index = 0, timer = null;

      var dots = slides.map(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'rb-heroS__dot';
        d.setAttribute('role', 'tab');
        d.setAttribute('aria-label', 'Slide ' + (i + 1));
        d.addEventListener('click', function () { go(i); restart(); });
        if (dotsWrap) dotsWrap.appendChild(d);
        return d;
      });

      function sync() {
        dots.forEach(function (d, i) {
          var on = i === index;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      function go(i) {
        index = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (index * -100) + '%)';
        sync();
      }

      function start() {
        if (root.getAttribute('data-autoplay') !== 'true') return;
        var secs = parseInt(root.getAttribute('data-interval'), 10) || 6;
        stop();
        timer = setInterval(function () { go(index + 1); }, secs * 1000);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      /* Po ručním kliknutí restartuje odpočet, ať slide hned neuteče */
      function restart() { stop(); start(); }

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

      sync(); start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-product-main"] && !Shopify.designMode) return;
  try {
    
  /* Miniatury přepínají hlavní obrázek */
  document.querySelectorAll('[data-rb-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.getElementById('rb-pd-main');
      if (!main) return;
      main.removeAttribute('srcset');
      main.src = thumb.getAttribute('data-full');
      document.querySelectorAll('[data-rb-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  });

  /* Počet kusů */
  document.querySelectorAll('[data-rb-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.rb-pd__qty');
      if (!wrap) return;
      var input = wrap.querySelector('.rb-pd__qty-input');
      var value = parseInt(input.value, 10) || 1;
      value = btn.getAttribute('data-rb-qty') === '+' ? value + 1 : value - 1;
      input.value = value < 1 ? 1 : value;
    });
  });

  /* Skokové tlačítko v buy boxu plynule odscrolluje na „O knize". */
  document.querySelectorAll('[data-rb-desc-jump]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var target = document.getElementById('rb-pd-about');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rb-slider]').forEach(function (root) {
    var track = root.querySelector('[data-rb-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    if (!track || slides.length < 2) return;

    var prev = root.querySelector('[data-rb-prev]');
    var next = root.querySelector('[data-rb-next]');
    var dotsWrap = root.querySelector('[data-rb-dots]');
    var index = 0;
    var timer = null;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Tečky
    var dots = slides.map(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'rb-slider__dot';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', 'Slide ' + (i + 1));
      dot.addEventListener('click', function () { goTo(i); stop(); });
      if (dotsWrap) dotsWrap.appendChild(dot);
      return dot;
    });

    function sync() {
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }

    function goTo(i) {
      index = Math.max(0, Math.min(i, slides.length - 1));
      track.scrollTo({
        left: slides[index].offsetLeft - track.offsetLeft,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
      sync();
    }

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); stop(); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); stop(); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); stop(); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(index - 1); stop(); }
    });

    // Ruční scroll / swipe → dopočítej aktivní slide
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var nearest = 0;
        var best = Infinity;
        slides.forEach(function (slide, i) {
          var delta = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (delta < best) { best = delta; nearest = i; }
        });
        index = nearest;
        sync();
      }, 100);
    });

    // Autoplay
    function start() {
      if (reduceMotion) return;
      if (root.getAttribute('data-autoplay') !== 'true') return;
      var seconds = parseInt(root.getAttribute('data-interval'), 10) || 6;
      stop();
      timer = setInterval(function () {
        goTo(index === slides.length - 1 ? 0 : index + 1);
      }, seconds * 1000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('focusin', stop);
    root.addEventListener('mouseleave', start);

    sync();
    start();
  });

  } catch(e) { console.error(e); }
})();
})();
